export type LanguageCode =
  | 'en-US'
  | 'de-DE'
  | 'el-GR'
  | 'es-ES'
  | 'fr-FR'
  | 'hi-IN'
  | 'ja-JP'
  | 'ko-KR'
  | 'pt-BR'
  | 'ru-RU'
  | 'th-TH'
  | 'fil-PH'
  | 'uk-UA'
  | 'vi-VN'
  | 'zh-CN'
  | 'ar-SA';

export type Language = {
  value: LanguageCode;
  label: string;
  abbreviation: string;
};

export const LANGUAGES: Language[] = [
  {
    value: 'en-US',
    abbreviation: 'EN',
    label: 'EN - English',
  },
  // To be added when UI is ready
  // {
  //   value: 'ar-SA',
  //   abbreviation: 'AR',
  //   label: 'AR - Arabic',
  // },
  {
    value: 'de-DE',
    abbreviation: 'DE',
    label: 'DE - Deutsch',
  },
  {
    value: 'el-GR',
    abbreviation: 'EL',
    label: 'EL - Ελληνικά',
  },
  {
    value: 'es-ES',
    abbreviation: 'ES',
    label: 'ES - Español',
  },
  {
    value: 'fr-FR',
    abbreviation: 'FR',
    label: 'FR - Français',
  },
  {
    value: 'hi-IN',
    abbreviation: 'HI',
    label: 'HI - हिन्दी',
  },
  {
    value: 'ja-JP',
    abbreviation: 'JA',
    label: 'JA - 日本語',
  },
  {
    value: 'ko-KR',
    abbreviation: 'KO',
    label: 'KO - 한국어',
  },
  {
    value: 'pt-BR',
    abbreviation: 'PT',
    label: 'PT - Português (Brasil)',
  },
  {
    value: 'ru-RU',
    abbreviation: 'RU',
    label: 'RU - Русский',
  },
  {
    value: 'th-TH',
    abbreviation: 'TH',
    label: 'TH - ไทย',
  },
  {
    value: 'fil-PH',
    abbreviation: 'TL',
    label: 'TL - Filipino (Tagalog)',
  },
  {
    value: 'uk-UA',
    abbreviation: 'UK',
    label: 'UK - Українська',
  },
  {
    value: 'vi-VN',
    abbreviation: 'VI',
    label: 'VI - Tiếng Việt',
  },
  {
    value: 'zh-CN',
    abbreviation: 'ZH',
    label: 'ZH - 中文 (简体)',
  },
];
